<template>
    <div class="canvas-host doughnut">
        <canvas ref="canvasEl" />
    </div>
</template>

<script setup>
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { createDoughnutChart } from "../../helpers/dashboardChartFactory";

const props = defineProps({
    labels: {
        type: Array,
        default: () => [],
    },
    data: {
        type: Array,
        default: () => [],
    },
});

const canvasEl = ref(null);
let chartInstance = null;

async function draw() {
    if (chartInstance) {
        chartInstance.destroy();
        chartInstance = null;
    }
    await nextTick();
    if (!canvasEl.value || !props.labels?.length || !props.data?.length) {
        return;
    }
    chartInstance = createDoughnutChart(canvasEl.value, {
        labels: props.labels,
        data: props.data,
    });
}

watch(
    () => [props.labels, props.data],
    () => {
        draw();
    },
    { deep: true },
);

onMounted(() => {
    draw();
});

onBeforeUnmount(() => {
    if (chartInstance) {
        chartInstance.destroy();
        chartInstance = null;
    }
});
</script>

<style scoped lang="scss">
.canvas-host {
    position: relative;
    width: 100%;
    height: 260px;
    max-width: 420px;
    margin: 0 auto;
}
</style>
